module.exports = __webpack_public_path__ + "static/media/brand-refresh-logo-new.bfdc8a51.svg";